"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _EdgeEnd = _interopRequireDefault(require("../../geomgraph/EdgeEnd"));

var _Label = _interopRequireDefault(require("../../geomgraph/Label"));

var _ArrayList = _interopRequireDefault(require("../../../../../java/util/ArrayList"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var EdgeEndBuilder =
/*#__PURE__*/
function () {
  function EdgeEndBuilder() {
    _classCallCheck(this, EdgeEndBuilder);

    EdgeEndBuilder.constructor_.apply(this, arguments);
  }

  _createClass(EdgeEndBuilder, [{
    key: "createEdgeEndForNext",
    value: function createEdgeEndForNext(edge, l, eiCurr, eiNext) {
      var iNext = eiCurr.segmentIndex + 1;
      if (iNext >= edge.getNumPoints() && eiNext === null) return null;
      var pNext = edge.getCoordinate(iNext);
      if (eiNext !== null && eiNext.segmentIndex === eiCurr.segmentIndex) pNext = eiNext.coord;
      var e = new _EdgeEnd.default(edge, eiCurr.coord, pNext, new _Label.default(edge.getLabel()));
      l.add(e);
    }
  }, {
    key: "createEdgeEndForPrev",
    value: function createEdgeEndForPrev(edge, l, eiCurr, eiPrev) {
      var iPrev = eiCurr.segmentIndex;

      if (eiCurr.dist === 0.0) {
        if (iPrev === 0) return null;
        iPrev--;
      }

      var pPrev = edge.getCoordinate(iPrev);
      if (eiPrev !== null && eiPrev.segmentIndex >= iPrev) pPrev = eiPrev.coord;
      var label = new _Label.default(edge.getLabel());
      label.flip();
      var e = new _EdgeEnd.default(edge, eiCurr.coord, pPrev, label);
      l.add(e);
    }
  }, {
    key: "computeEdgeEnds",
    value: function computeEdgeEnds() {
      if (arguments.length === 1) {
        var edges = arguments[0];
        var l = new _ArrayList.default();

        for (var i = edges; i.hasNext();) {
          var e = i.next();
          this.computeEdgeEnds(e, l);
        }

        return l;
      } else if (arguments.length === 2) {
        var edge = arguments[0],
            _l = arguments[1];
        var eiList = edge.getEdgeIntersectionList();
        eiList.addEndpoints();
        var it = eiList.iterator();
        var eiPrev = null;
        var eiCurr = null;
        if (!it.hasNext()) return null;
        var eiNext = it.next();

        do {
          eiPrev = eiCurr;
          eiCurr = eiNext;
          eiNext = null;
          if (it.hasNext()) eiNext = it.next();

          if (eiCurr !== null) {
            this.createEdgeEndForPrev(edge, _l, eiCurr, eiPrev);
            this.createEdgeEndForNext(edge, _l, eiCurr, eiNext);
          }
        } while (eiCurr !== null);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EdgeEndBuilder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EdgeEndBuilder;
}();

exports.default = EdgeEndBuilder;

EdgeEndBuilder.constructor_ = function () {};